import api from './api';

export const getSubscriptionPlans = async () => {
  const response = await api.get('/subscriptions/plans');
  return response.data;
};

export const createSubscription = async (subscriptionData) => {
  const response = await api.post('/subscriptions/subscribe', subscriptionData);
  return response.data;
};

export const getSubscriptionStatus = async () => {
  const response = await api.get('/subscriptions/status');
  return response.data;
};

export const getSubscriptionDetails = async () => {
  const response = await api.get('/subscriptions/details');
  return response.data;
};

export const cancelSubscription = async () => {
  const response = await api.post('/subscriptions/cancel');
  return response.data;
};

export const updateSubscription = async (planId) => {
  const response = await api.post('/subscriptions/update', { plan_id: planId });
  return response.data;
};